<app-toaster themeType="dark"></app-toaster>
<app-loader></app-loader>
<router-outlet/>

<!--@if (!environment.production) {-->
<!--  <app-api-load-test-panel />-->
<!--}-->
